export enum AuthTokenType {
    OktaExternal = 'OktaExternal',
    OktaInternal = 'OktaInternal',
    AWSCognito = 'AWSCognito',
}
